import i from "react";
import "../../../../../Accordion/Accordion.js";
import "../../../../../AdCard/AdCard.js";
import "../../../../../AdCardImageCarousel/AdCardImageCarousel.js";
import "../../../../../AdMediaCounter/AdMediaCounter.js";
import "../../../../../Alertbox/Alertbox.js";
import "../../../../../Alertbox/Links.js";
import "../../../../../ArrowButton/ArrowButton.js";
import "../../../../../Autocomplete/Autocomplete.js";
import "../../../../../Autocomplete/AutocompleteListItem.js";
import "../../../../../Avatar/Avatar.js";
import "../../../../../Badge/Badge.js";
import "../../../../../Breadcrumb/Breadcrumb.js";
import "../../../../../Button/Button.js";
import "../../../../../ButtonSocial/ButtonSocial.js";
import "../../../../../Card/Card.js";
import "../../../../../CardCoverImage/CardCoverImage.js";
import "../../../../../CardSuggestion/CardSuggestion.js";
import "../../../../../CardTopImage/CardTopImage.js";
import "../../../../../Carousel/Carousel.js";
import "../../../../../Carousel/components/CarouselNext.js";
import "../../../../../Carousel/components/CarouselPrevious.js";
import "../../../../../Carousel/components/CarouselContent.js";
import "../../../../../Carousel/components/CarouselItem.js";
import "embla-carousel-autoplay";
import "embla-carousel-react";
import "../../../../../Checkbox/Checkbox.js";
import "../../../../../Chip/Chip.js";
import "../../../../../Chips/Chips.js";
import "../../../../../Container/Container.js";
import "../../../../../Divider/Divider.js";
import "../../../../../Dropdown/Dropdown.js";
import { Flex as e } from "../../../../../Flex/Flex.js";
import "../../../../../FocusHeader/FocusHeader.js";
import "../../../../../Footer/Footer.js";
import "../../../../../FormControl/FormControl.js";
import "../../../../Header.js";
import "../../../../../HelpText/HelpText.js";
import "../../../../../IconAction/IconAction.js";
import "../../../../../ImageCarousel/ImageCarousel.js";
import "../../../../../InputChips/InputChips.js";
import "../../../../../LayoutContainer/LayoutContainer.js";
import "../../../../../Link/Link.js";
import "../../../../../LogoCompraSegura/LogoCompraSegura.js";
import "../../../../../LogoOLX/LogoOLX.js";
import "../../../../../LogoOLXPay/LogoOLXPay.js";
import "../../../../../LogoOLXPayPlusDelivery/LogoOLXPayPlusDelivery.js";
import "../../../../../Lurker/Lurker.js";
import "../../../../../MediaCounter/MediaCounter.js";
import "../../../../../Modal/Modal.js";
import "../../../../../Multiselect/Multiselect.js";
import "../../../../../Navbar/Navbar.js";
import "../../../../../Overflow/Overflow.js";
import "../../../../../PriceReferenceRuler/PriceReferenceRuler.js";
import "../../../../../ProgressBar/ProgressBar.js";
import "../../../../../ProgressCircle/ProgressCircle.js";
import "../../../../../ProgressStepped/ProgressStepped.js";
import "../../../../../Radio/Radio.js";
import "../../../../../Skeleton/Skeleton.js";
import "../../../../../Slider/Slider.js";
import "../../../../../Slider/RangeSlider.js";
import "../../../../../Spinner/Spinner.js";
import "../../../../../Tabs/Tabs.js";
import "../../../../../Tabs/components/Tab/Tab.js";
import { Text as g } from "../../../../../Text/Text.js";
import "../../../../../TextArea/TextArea.js";
import "../../../../../TextInput/TextInput.js";
import "../../../../../Toast/Toast.js";
import "../../../../../ToggleSwitch/ToggleSwitch.js";
import "../../../../../Tooltip/Tooltip.js";
import "clsx";
import { TilesGrid as f } from "./components/TilesGrid/TilesGrid.js";
import { Tile as b } from "./components/Tile/Tile.js";
import { tileLinks as x } from "./tileLinks.js";
import "@olxbr/ds-icons";
import { sendClickEvent as h } from "../../../../utils/sendClickEvent.js";
import { DrawerHeader as w } from "./components/DrawerHeader/index.js";
import { NewBadge as E } from "./components/NewBadge/index.js";
const k = _ref => {
  let {
    accountInfo: p,
    hasNavbar: a,
    openSubMenu: o,
    enableNewBadge: l
  } = _ref;
  const {
      userName: n,
      profilePicture: c,
      publicAccountId: s
    } = p,
    r = (t, d) => {
      const u = d ? "_blank" : "_self";
      h(t.objectDetail, "mosaic", {
        menuPro: !0,
        isAutosPro: !0,
        hasNavbar: !0
      }), window.open(t.link, u);
    },
    m = t => t && l ? i.createElement(E, null) : null;
  return i.createElement(e, {
    flexDirection: "column",
    className: "olx-header__overflow-highlighted-section",
    tag: "li"
  }, i.createElement(w, {
    alt: "Foto de perfil",
    src: c,
    text: n,
    badge: m(!0),
    publicAccountId: s,
    trackingData: {
      login: !0,
      isAutosPro: !0,
      menuPro: !0,
      hasNavbar: !!a
    },
    tabIndex: o ? 0 : -1
  }), i.createElement(e, {
    padding: "--spacing-2",
    flexDirection: "column"
  }, i.createElement(g.BodyMedium, {
    marginBottom: "--spacing-1-5",
    weight: "semibold"
  }, "Acessos r\xE1pidos"), i.createElement(f, {
    rowLayouts: ["single", "pair", "pair"]
  }, x.map(t => i.createElement(b, {
    key: "mosaic-tile-".concat(t.objectDetail),
    onClick: () => r(t),
    onAuxClick: () => r(t, !0),
    image: t.image,
    title: t.title,
    "data-mosaic": !0,
    tabIndex: o ? 0 : -1,
    badge: m(t.isNew)
  })))));
};
export { k as OverflowHighlightedSection };